import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconDownloadFileFill = ({
  width = 24,
  height = 24,
  fill = '#1D2225',
  ...props
}: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill={fill}
        d="M10.627 2.375a1.35 1.35 0 0 1 .956.396l3.146 3.146c.124.123.22.269.29.436.07.166.106.34.106.52v8.397c0 .378-.131.699-.394.961a1.309 1.309 0 0 1-.961.394H5.23c-.378 0-.699-.131-.961-.394a1.309 1.309 0 0 1-.394-.962V3.73c0-.378.131-.699.394-.961.262-.263.583-.394.961-.394h5.397ZM9.504 9.09a.546.546 0 0 0-.401.162.545.545 0 0 0-.162.4v2.764l-.992-.992a.56.56 0 0 0-.188-.125.489.489 0 0 0-.21-.036.638.638 0 0 0-.206.047.589.589 0 0 0-.354.521.525.525 0 0 0 .167.395l1.871 1.87a.624.624 0 0 0 .475.192.626.626 0 0 0 .475-.191l1.87-1.871a.529.529 0 0 0 .165-.392.557.557 0 0 0-.176-.399.59.59 0 0 0-.396-.168.527.527 0 0 0-.395.168l-.98.981V9.652a.545.545 0 0 0-.163-.4.544.544 0 0 0-.4-.162Zm1.121-2.893c0 .194.065.354.194.484.13.129.29.194.484.194H14L10.625 3.5v2.697Z"
      />
    </Svg>
  );
};

export default IconDownloadFileFill;
